import React from 'react';
import { useSelector } from 'react-redux';
import { useParameterizedQuery } from 'react-fetching-library';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Stack, Card, CardContent, Modal, Portal, IconButton, TextField, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { getOrdersAction } from '../../../../services/request';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const columns = [
  { field: 'identifier', headerName: 'Numer zamówienia', flex: 1 },
  { field: 'guardian_name', headerName: 'Opiekun', flex: 1 },
  { field: 'participant_name', headerName: 'Uczestnik', flex: 1 },
  { field: 'guardian_phone', headerName: 'Numer telefonu', flex: 1 }
];

const searchFields = ['identifier', 'guardian_name', 'participant_name', 'guardian_phone'];

const columnsZs = [
  { field: 'identifier', headerName: 'Numer zamówienia', flex: 1 },
  { field: 'school_name', headerName: 'Nazwa szkoły', flex: 1 },
  { field: 'agreement_signer_surname', headerName: 'Nazwisko osoby upoważnionej do podpisania umowy', flex: 1 },
  { field: 'office_representative_surname', headerName: 'Nazwisko osoby reprezentującej szkołę w kontaktach z biurem', flex: 1 },
  { field: 'office_representative_correspondence_email', headerName: 'E-mail osoby reprezentującej szkołę w kontaktach z biurem', flex: 1 }
];

const searchFieldsZS = ['identifier', 'school_name', 'agreement_signer_surname', 'office_representative_correspondence_email'];

const SearchOrderModal = ({ handleClose, setOrderNumber }) => {
  const { module } = useSelector(state => state.app);
  const { query } = useParameterizedQuery(getOrdersAction);
  const [orders, setOrders] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [selectionModel, setSelectionModel] = React.useState([]);

  const handleChange = e => setSearch(e.target.value);

  const handleClick = async () => {
    const { payload, error, loading } = await query(1, 100, search, undefined, module === 'zielone_szkoly' ? searchFieldsZS : searchFields);
    if (!error) {
      setOrders(payload.results);
    }
  };

  const handleSelect = () => {
    const order = orders.find(element => element.id === selectionModel[0]);
    setOrderNumber(order.identifier);
    handleClose();
  };

  return (
    <Portal>
      <Modal open={true}>
        <Card sx={{ ...style, width: '80vw', height: '80vh' }}>
          <CardContent style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Stack direction="row" spacing={2}>
              <TextField fullWidth placeholder="wyszukaj zamówienie" value={search} onChange={handleChange} />
              <IconButton onClick={handleClick}>
                <SearchIcon />
              </IconButton>
            </Stack>
            <DataGridPro
              sx={{
                boxShadow: 10,
                borderRadius: '10px',
                mt: '40px',
                mb: '40px',
                flex: 1
              }}
              rows={orders}
              columns={module === 'zielone_szkoly' ? columnsZs : columns}
              pagination
              localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
              onSelectionModelChange={newSelection => {
                setSelectionModel(newSelection);
              }}
              selectionModel={selectionModel}
            />
            <Stack direction="row" spacing={4}>
              <Button variant="outlined" fullWidth onClick={handleClose}>anuluj</Button>
              <Button variant="contained" fullWidth disabled={selectionModel.length === 0} onClick={handleSelect}>wybierz</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};


export default SearchOrderModal;
